import { Button, IconButton } from '@mui/material';
import './shapes.css';
import { useState } from "react";
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { FaCircle, FaCube, FaTree } from 'react-icons/fa';
import circle from "../../../../../assets/shapes/circle.png";
import pyramid from "../../../../../assets/shapes/pyramid.png";
import spiral from "../../../../../assets/shapes/spiral.png";

import balls1 from "../../../../../assets/shapes/balls/taxus2.webp";
import balls2 from "../../../../../assets/shapes/balls/abelia.webp";
import balls3 from "../../../../../assets/shapes/balls/evonimus.jpg";
import balls4 from "../../../../../assets/shapes/balls/ilex.jpg";
import balls5 from "../../../../../assets/shapes/balls/ligistrum.jpg";
import balls6 from "../../../../../assets/shapes/balls/loropetalum.webp";
import balls7 from "../../../../../assets/shapes/balls/pultaspurum.jpg";
import balls8 from "../../../../../assets/shapes/balls/buxus.webp";
import balls9 from "../../../../../assets/shapes/balls/GOLD CREST.jpg";
import balls10 from "../../../../../assets/shapes/balls/thuya.jpg";
import balls11 from "../../../../../assets/shapes/balls/eleagnus.jpg";
import balls12 from "../../../../../assets/shapes/balls/vibuenum tree.avif";
import pyramid1 from "../../../../../assets/shapes/pyramids/eveginia.jpg";
import pyramid2 from "../../../../../assets/shapes/pyramids/Photinia.webp";
import pyramid3 from "../../../../../assets/shapes/pyramids/barcanda.jpg";
import pyramid5 from "../../../../../assets/shapes/pyramids/laurus.jpg";
import pyramid4 from "../../../../../assets/shapes/pyramids/magnolia.jpg";

import spiral1 from "../../../../../assets/shapes/spiral/leylandy.jpg";
import spiral2 from "../../../../../assets/shapes/spiral/spiral-Gold-crest.jpg";
import spiral3 from "../../../../../assets/shapes/spiral/thuya2.webp";

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BackIcon from '../../../../../components/back/back';
const shapeFamilies = {
    Balls: [
        { id: 1, name: "Taxus", img: balls1, url: "/flowers" },
        { id: 2, name: "Abelia", img: balls2, url: "/fruits" },
        { id: 3, name: "Evonimus", img: balls3, url: "/quercus" },
        { id: 4, name: "Ilex", img: balls4, url: "/palms" },
        { id: 5, name: "Ligistrum", img: balls5, url: "/ficus" },
        { id: 6, name: "Loropetalum", img: balls6, url: "/indoors" },
        { id: 7, name: "Pultaspurum", img: balls7, url: "/acer" },
        { id: 8, name: "Buxus", img: balls8, url: "/olives" },
        { id: 9, name: "Gold Crest", img: balls9, url: "/climbers" },
        { id: 10, name: "Thuya", img: balls10, url: "/cedrus" },
        { id: 11, name: "Eleagnus", img: balls11, url: "/blossom" },
        { id: 12, name: "Vibuenum", img: balls12, url: "/shapes" },
    ],
    Pyramids: [
        { id: 1, name: "Taxus", img: balls1, url: "/flowers" },
        { id: 2, name: "Abelia", img: balls2, url: "/fruits" },
        { id: 3, name: "Photinia", img: pyramid1, url: "/quercus" },
        { id: 4, name: "Ilex", img: balls4, url: "/palms" },
        { id: 5, name: "Evginea", img: pyramid2, url: "/ficus" },
        { id: 6, name: "Loropetalum", img: balls6, url: "/indoors" },
        { id: 7, name: "Barcanda", img: pyramid3, url: "/acer" },
        { id: 8, name: "Buxus", img: balls8, url: "/olives" },
        { id: 9, name: "Gold Crest", img: balls9, url: "/climbers" },
        { id: 10, name: "Magnolia", img: pyramid4, url: "/cedrus" },
        { id: 11, name: "Laurus Nobilis", img: pyramid5, url: "/blossom" },
    ],
    "Spiral/Multi-Ball": [
        { id: 1, name: "Leylandi", img: spiral1, url: "/flowers" },
        { id: 2, name: "Gold Crest", img: spiral2, url: "/fruits" },
        { id: 3, name: "Thuya", img: spiral3, url: "/quercus" },
    ],
};

type ShapeFamily = keyof typeof shapeFamilies;

export default function ShapesDesktop() {
    const [selectedFamily, setSelectedFamily] = useState<ShapeFamily>("Balls");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 4;


    const shapes = shapeFamilies[selectedFamily];


    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentShapes = shapes.slice(indexOfFirstItem, indexOfLastItem);


    const totalPages = Math.ceil(shapes.length / itemsPerPage);

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <div className="shapes-container">
            <BackIcon />
            <div className="title-overlay">
                <h1>Shapes Collection</h1>
            </div>
    

            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#1B4D3E", padding: "15px", gap: "rem" }} >

                {(Object.keys(shapeFamilies) as ShapeFamily[]).map((family) => (
                    <Button
                        key={family}

                        sx={{
                            color: selectedFamily === family ? "#c46210" : "white",
                            '&:hover': {
                                color: "#c46210",
                            }
                        }}
                        onClick={() => {
                            setSelectedFamily(family);
                            setCurrentPage(1);
                        }}
                    >
                        {family}
                    </Button>
                ))}

            </div>

            <div className="plants-category-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8" style={{ marginTop: "5rem" }}>
                {currentShapes.map((shape) => (
                    <div key={shape.id} className=" plant-shape-card bg-white p-6 rounded-xl shadow-lg transform transition-all hover:scale-105">
                        <img
                            src={shape.img}
                            alt={shape.name}
                            className="w-full h-60 object-cover rounded-lg mb-4"
                        />
                        <p className="plant-name">{shape.name}</p>
                    </div>
                ))}
            </div>


            <div className="pagination-controls flex justify-center gap-4 mt-6" style={{ marginTop: "1rem" }}>
                <IconButton
                    onClick={handlePrevPage}

                    sx={{
                        color: "#1B4D3E",
                        '&:hover': {
                            color: "#a45b0c",
                            transition: "color 0.3s ease-in-out"
                        },
                        transition: "transform 0.3s ease-in-out",
                        '&:active': {
                            transform: "scale(0.95)"
                        }
                    }}
                >
                    <ArrowBackIcon sx={{ fontSize: "5rem" }} />
                </IconButton>

                <IconButton
                    onClick={handleNextPage}

                    sx={{
                        color: "#1B4D3E",
                        '&:hover': {
                            color: "#a45b0c",
                            transition: "color 0.3s ease-in-out"
                        },
                        transition: "transform 0.3s ease-in-out",
                        '&:active': {
                            transform: "scale(0.95)"
                        }
                    }}
                >
                    <ArrowForwardIcon sx={{ fontSize: "5rem" }} />
                </IconButton>
            </div>
        </div>
    );
}